// Modo Motori — Landing page data (v2, editorial light)
// Verified data from https://www.youtube.com/@modo-motori/about on 15 Oct 2026.

export const CHANNEL_URL = "https://www.youtube.com/@modo-motori";
export const CHANNEL_ABOUT_URL = "https://www.youtube.com/@modo-motori/about";

export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_modo-media-kit/artifacts/1ysljo0k_channels4_profile.jpg";

// Hero image (uploaded by client: dark sports car render)
export const HERO_IMAGE = (process.env.PUBLIC_URL || "") + "/hero-auto-nera.webp";

// Reel product hero (uploaded by client)
export const CREATOR_IMAGE =
  "https://customer-assets-agu9un31.emergentagent.net/job_modo-media-kit/artifacts/18763761ad630eee_creator-social-video.jpg";

// Email contact — to be configured by the client. Leave empty to display placeholder.
export const CONTACT_EMAIL = "modo@deltapictures.it";

// Fallback values shown only if the live YouTube API is unreachable.
// When YOUTUBE_API_KEY is configured, numbers update automatically (see /api/youtube/stats).
export const STATS_VERIFIED_ON = "15 ottobre 2026";

export const STATS = [
  { key: "iscritti", label: "Iscritti al canale", value: 7220, display: "7.220" },
  { key: "visualizzazioni", label: "Visualizzazioni complessive", value: 1109660, display: "1.109.660" },
  { key: "video", label: "Video pubblicati", value: 319, display: "319" },
];

export const NAV = [
  { href: "#pubblico", label: "Il pubblico" },
  { href: "#proposte", label: "Le proposte" },
  { href: "#distribuzione", label: "La distribuzione" },
];

// Playlists verified from YouTube
export const COLPO_DI_CLACSON = {
  playlistId: "PLNRTbiByyYjQ",
  playlistUrl: "https://www.youtube.com/playlist?list=PLNRTbiByyYjQ",
  videosCount: 4,
  featuredVideoId: "RY4Wlv9mywc", // 8:00 full episode
  thumbnail: "https://i.ytimg.com/vi/RY4Wlv9mywc/maxresdefault.jpg",
};

export const IL_NOSTRO_GARAGE = {
  playlistId: "PLDwTulzySgX13zbupseuPneWdhK5R26wT",
  playlistUrl: "https://www.youtube.com/playlist?list=PLDwTulzySgX13zbupseuPneWdhK5R26wT",
  videosCount: 36,
  featuredVideoId: "A3RYty3GZG8", // EMC 212 — 11K views, highest
  thumbnail: "https://i.ytimg.com/vi/A3RYty3GZG8/maxresdefault.jpg",
  samples: [
    { id: "A3RYty3GZG8", title: "EMC 212: il SUV che fa girare la testa" },
    { id: "aO4wEO8c85A", title: "BYD Dolphin: design, tecnologia e semplicità" },
    { id: "hXVFckrFSuc", title: "Peugeot 208: stile e tecnologia compatti" },
  ],
};

// Ecosystem distribution — editorial network sites verified via YouTube channel description
export const ECOSYSTEM_SITES = [
  { name: "Motorinews24", url: "https://www.motorinews24.com/" },
  { name: "Mondo Motori", url: "https://mondo-motori.it/" },
  { name: "NewsMondo", url: "https://newsmondo.it/" },
];

export const ECOSYSTEM_CHANNELS = [
  { key: "articoli", label: "Articoli editoriali", note: "Pubblicazioni dedicate sulle testate del gruppo." },
  { key: "banner", label: "Banner pubblicitari", note: "Posizionamenti grafici in homepage e nelle sezioni verticali." },
  { key: "dem", label: "DEM", note: "Direct Email Marketing al database profilato del network." },
  { key: "newsletter", label: "Newsletter", note: "Rimandi editoriali nelle newsletter periodiche delle testate." },
  { key: "social", label: "Contenuti social", note: "Distribuzione su Facebook, Instagram e piattaforme social del gruppo." },
  { key: "youtube", label: "YouTube", note: "Canale Modo Motori — 7.220 iscritti, 319 video, oltre 1,1M visualizzazioni." },
];
